module.exports = __webpack_public_path__ + "Flama-BasicItalic.ttf?5b5526507be164a9cf7c11113ee62985";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-BasicItalic.ttf
// module id = 889
// module chunks = 0